import React from "react";
import { Container, Box, Card, CardContent, Typography, Stack, Button } from "@mui/material";
import { Phone, Textsms } from "@mui/icons-material";
const contacts = [
  { name: "Youssef Bourouphael", phone: "978 235 3701" },
  { name: "Anubhav Adhikari", phone: "740 405 3107" },
];

const formatTelLink = (phone: string) => `tel:${phone.replace(/\s+/g, "")}`;
const formatSmsLink = (phone: string) => `sms:${phone.replace(/\s+/g, "")}`;

const formatPhoneNumber = (phoneNumber: string): string => {
  const digits = phoneNumber.replace(/\D/g, '');

  if (digits.length === 11 && digits.startsWith('1')) {
    const area = digits.slice(1, 4);
    const middle = digits.slice(4, 7);
    const last = digits.slice(7);
    return `+1 (${area}) ${middle}-${last}`;
  }

  if (digits.length === 10) {
    const area = digits.slice(0, 3);
    const middle = digits.slice(3, 6);
    const last = digits.slice(6);
    return `(${area})-${middle}-${last}`;
  }

  return phoneNumber;
};

const ContactSupportPage: React.FC = () => {
  return (
    <Container sx={{ mt: { xs: 4, md: 6 }, display: "flex", justifyContent: "center" }}>
      <Box sx={{ maxWidth: 520, width: "100%" }}>
        <Typography variant="body1" align="center" color="text.secondary" sx={{ mb: 3 }}>
          Call or text us anytime, we are here to help!
        </Typography>

        <Stack spacing={2}>
          {contacts.map((contact) => (
            <Card key={contact.name} elevation={2} sx={{ borderRadius: 2 }}>
              <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                <Typography variant="h6" sx={{ fontWeight: 550 }}>
                  {contact.name}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {formatPhoneNumber(contact.phone)}
                </Typography>
                <Stack direction="row" spacing={1.5} sx={{ flexWrap: 'nowrap' }}>
                  <Button
                    sx={{ flex: 1 }}
                    variant="contained"
                    color="primary"
                    startIcon={<Phone />}
                    component="a"
                    href={formatTelLink(contact.phone)}
                  >
                    Call
                  </Button>
                  <Button
                    sx={{ flex: 1 }}
                    variant="outlined"
                    color="primary"
                    startIcon={<Textsms />}
                    component="a"
                    href={formatSmsLink(contact.phone)}
                  >
                    Text
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </Box>
    </Container>
  );
};

export default ContactSupportPage;
